<template>
  <div
    class="user-tex d-flex align-baseline m-2 font-weight-bold"
    style="min-height: min-content"
  >
    <span
      class="whole textOverSecondary--text"
      :class="{ small: currency && currency.length > 1 }"
      >{{ whole(balance) }}</span
    >
    <span
      v-if="showDecimal"
      class="decimal textOverSecondary--text"
      :class="{ small: currency && currency.length > 1 }"
      >{{ $t("decimal_separator") }}</span
    >
    <span
      v-if="showDecimal"
      class="decimal textOverSecondary--text"
      :class="{ small: currency && currency.length > 1 }"
      >{{ decimalAmount != null ? decimalAmount : decimal(balance) }}</span
    >
    <v-icon color="textOverSecondary" class="mt-3" small style="top: 2px">{{
      currency
    }}</v-icon>
  </div>
</template>

<script>
import { whole, decimal } from "../utils/MoneyUtils";
import { mapState } from "vuex";

export default {
  props: {
    balance: Number,
    showDecimal: Boolean,
    decimalAmount: String,
  },
  computed: {
    ...mapState({
      currency: (state) =>
        state.customization.customization.economics.currency_symbol,
    }),
  },
  methods: {
    decimal,
    whole,
  },
};
</script>

<style scoped lang="scss">
.whole {
  font-size: 60px;
  line-height: 100%;
  &.small {
    font-size: 35px;
    line-height: 60px;
  }
}
.decimal {
  font-size: 25px;
  line-height: 100%;
  &.small {
    font-size: 15px;
  }
}
.currency {
  font-size: 35px;
  line-height: 100%;
  &.small {
    font-size: 15px;
  }
}
</style>
